export class ApiError extends Error {
  readonly code;
  constructor(code: number, message: string) {
    super(message);
    this.code = code;
  }
}
